export const OAKey = {
  tDLosses_TF: 'T&D loss rate',
  electricSold_TF: 'Electricity Sold'
};
export const OALabel = {
  tDLosses_TF: 'T&D loss rate',
  electricSold_TF: 'Electricity Sold',
  STATUS_COMMENTS: 'Status & Comments',
  FULL_INFO: 'Full Info',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
